export default __webpack_public_path__ + "static/media/loading-6.55273466.jpeg";